<template>
  <modal :title="$t('titles.printStyle')">
    <menu-item
      v-for="printStyle in printStyles"
      :key="printStyle"
      :collapsable="true"
      @collapsed="show => trackPrintStyle(show, printStyle)"
    >
      <div class="flex">
        <div class="w-8 flex items-center justify-center">
          <base-icon
            v-if="printStyle === printSidePrintStyle"
            name="check-icon"
            class="pin-r"
            size="xs"
          ></base-icon>
        </div>
        <div>
          {{ $t(`printStyles.${printStyle}.name`) }}
        </div>
      </div>

      <div slot="collapsable" class="p-2 pl-8">
        <div class="pl-2">
          <base-button
            :disabled="
              printStyle === printSidePrintStyle ||
              !activePrintPlateSupports(printStyle)
            "
            @click.native="switchPrintStyle(printStyle)"
          >
            {{
              $t('customization.applyPrintStyle', {
                name: $t(`printStyles.${printStyle}.name`)
              })
            }}
          </base-button>
        </div>
        <!-- eslint-disable vue/no-v-html -->

        <div
          class="m-2 text-sm text-justify"
          v-html="$t(`printStyles.${printStyle}.description`)"
        ></div>
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </menu-item>
  </modal>
</template>

<script>
import Modal from '../components/Modal.vue';
import MenuItem from '../components/MenuItem';
import BaseButton from '../components/BaseButton';
import BaseIcon from '../components/BaseIcon';
import { mapGetters } from 'vuex';
import {
  GETTER_ACTIVE_PRINT_SIDE_AVAILABLE_PRINT_STYLES,
  GETTER_ACTIVE_PRINT_SIDE_PRINT_STYLE
} from '@/store/getters';
import Capabilities from '@/mixins/capabilities';
import Redirect from '@/mixins/redirect';
import { TrackingMixin } from '@/mixins/gtm-tracking';
import { useControlLayerStore } from '@/store-pinia/control-layer';

export default {
  name: 'SelectPrintStyle',
  components: {
    BaseIcon,
    BaseButton,
    MenuItem,
    Modal
  },
  mixins: [Capabilities, Redirect, TrackingMixin],
  computed: {
    ...mapGetters({
      printStyles: GETTER_ACTIVE_PRINT_SIDE_AVAILABLE_PRINT_STYLES,
      printSidePrintStyle: GETTER_ACTIVE_PRINT_SIDE_PRINT_STYLE
    })
  },
  methods: {
    trackPrintStyle(show, printStyle) {
      if (show) {
        this.trackEvent({
          action: 'PrintType_Detail',
          label: printStyle
        });
      }
    },
    switchPrintStyle(printStyle) {
      this.trackEvent({
        action: 'PrintType_Change',
        label: `${this.printSidePrintStyle}:${printStyle}`
      });
      this.closeModalAfter(() => this.$root.$emit('reset-navigation'));

      const controlLayerStore = useControlLayerStore();

      controlLayerStore.updateSidePrintStyle(
        controlLayerStore.activePrintSide,
        printStyle
      );
    }
  }
};
</script>
